import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
import { DescriptionList, Link, Flex, CountryFlag, Text, Tooltip, useId } from '@applyboard/crystal-ui';
import { useEventTracker, useTranslation } from '@applyboard/ui-utils';
import { Copyable } from "../../../../../components/Copyable";
import { assert } from "../../../../../utils/assert";
import { formatDetailedDeadline } from "../../../../../utils/dates";
import { useFormattedIntakeDetails } from "../../../../../utils/useFormattedIntakeDetails";
import { useApplicationPrograms } from "../../../data/programs";
import { useApplicationSchools } from "../../../data/school";
import { useApplication } from "../../../data/application";
import { useApplicationEslProgram, useApplicationMainProgram } from "../../../data";
import { SideBarDescriptionList } from "../SideBarDescriptionList";
import { ManageBackupProgramsButton } from "../../ManageBackupProgramsButton";
import { UnpublishedProgramsNotice } from "../../UnpublishedProgramsNotice";
import { useSideBarEventTracker } from "../../../utils/eventTracking";
import { ApplicationNoticeList } from "../ApplicationNoticeList";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function ApplicationDetails(_ref) {
  var copyEnabled = _ref.copyEnabled,
    hiddenSections = _ref.hiddenSections;
  var _useTranslation = useTranslation('ApplicationDetails'),
    t = _useTranslation.t;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useApplicationMainPr = useApplicationMainProgram(),
    mainProgramDetails = _useApplicationMainPr.mainProgramDetails,
    applicationMainProgram = _useApplicationMainPr.applicationMainProgram,
    mainIntake = _useApplicationMainPr.mainIntake;
  var _useApplicationEslPro = useApplicationEslProgram(),
    eslProgramDetails = _useApplicationEslPro.eslProgramDetails,
    applicationEslProgram = _useApplicationEslPro.applicationEslProgram,
    eslIntake = _useApplicationEslPro.eslIntake;
  return _jsx(_Fragment, {
    children: _jsxs(Flex, {
      direction: "column",
      gap: 6,
      children: [_jsxs(Flex, {
        direction: "column",
        gap: 4,
        children: [_jsx(ApplicationNoticeList, {
          regarding: "application"
        }), _jsxs(SideBarDescriptionList, {
          children: [_jsx(DescriptionList.Term, {
            children: t('applicationId')
          }), _jsx(DescriptionList.Details, {
            children: _jsx(Copyable, {
              disabled: !copyEnabled,
              children: application.legacyId
            })
          })]
        })]
      }), _jsx(ProgramDetails, {
        applicationProgram: applicationMainProgram,
        intake: mainIntake,
        programDetails: mainProgramDetails,
        hiddenSections: hiddenSections,
        copyEnabled: copyEnabled
      }), applicationEslProgram && eslProgramDetails && _jsx(ProgramDetails, {
        applicationProgram: applicationEslProgram,
        intake: eslIntake,
        programDetails: eslProgramDetails,
        hiddenSections: hiddenSections,
        copyEnabled: copyEnabled
      }), _jsx(BackupPrograms, {})]
    })
  });
}
function BackupPrograms() {
  var headingId = useId();
  var _useApplication2 = useApplication(),
    application = _useApplication2.application;
  var backupPrograms = useApplicationPrograms(application.backupPrograms);
  var publishedPrograms = backupPrograms.filter(function (program) {
    return program.published;
  });
  var unpublishedPrograms = backupPrograms.filter(function (program) {
    return !program.published;
  });
  return _jsxs("section", {
    "aria-labelledby": headingId,
    children: [_jsx(Text, {
      id: headingId,
      variant: "labelL",
      children: "BACKUP PROGRAMS"
    }), _jsxs(Flex, {
      direction: "column",
      gap: 4,
      pt: 4,
      children: [unpublishedPrograms.length > 0 && _jsx(UnpublishedProgramsNotice, {
        programNames: unpublishedPrograms.map(function (program) {
          return program.name;
        })
      }), publishedPrograms.length === 0 ? _jsx(Text, {
        contrast: "mid",
        children: "There are no backup programs added. Click \u201CAdd backup programs\u201D to add one or multiple programs."
      }) : publishedPrograms.map(function (backupProgram) {
        return _jsx(BackupProgramDetails, {
          program: backupProgram
        }, backupProgram.id);
      }), _jsx(ManageBackupProgramsButton, {})]
    })]
  });
}
function BackupProgramDetails(_ref2) {
  var program = _ref2.program;
  var _useEventTracker = useEventTracker({
      group: 'Single Application V2'
    }),
    trackEvent = _useEventTracker.trackEvent;
  var _useApplicationSchool = useApplicationSchools(),
    schools = _useApplicationSchool.schools;
  var school = schools.find(function (school) {
    return String(school.id) === String(program.schoolId);
  });
  assert(school, "Could not find school for backup program ".concat(program.id));
  return _jsxs(Text, {
    children: [_jsx(Link, {
      href: "/schools/".concat(school.id, "/programs/").concat(program.id),
      mode: "override_user_choice_and_open_in_new_tab",
      onClick: function onClick() {
        trackEvent({
          event: 'Single Application V2 - Sidebar - Application Details - Clicked Backup Program Link',
          data: {
            linkToProgram: "/schools/".concat(school.id, "/programs/").concat(program.id)
          }
        });
      },
      children: program.name
    }), "\xA0at\xA0", _jsx(Link, {
      href: "/schools/".concat(school.id),
      mode: "override_user_choice_and_open_in_new_tab",
      onClick: function onClick() {
        trackEvent({
          event: 'Single Application V2 - Sidebar - Application Details - Clicked Backup School Link',
          data: {
            linkToProgram: "/schools/".concat(school.id)
          }
        });
      },
      children: school.name
    })]
  }, program.id);
}
var ProgramDetails = function ProgramDetails(_ref3) {
  var _programDetails$requi, _programDetails$submi;
  var copyEnabled = _ref3.copyEnabled,
    applicationProgram = _ref3.applicationProgram,
    programDetails = _ref3.programDetails,
    intake = _ref3.intake,
    hiddenSections = _ref3.hiddenSections;
  var _useTranslation2 = useTranslation('ApplicationDetails'),
    t = _useTranslation2.t;
  var trackEvent = useSideBarEventTracker();
  var _useApplicationSchool2 = useApplicationSchools(),
    schools = _useApplicationSchool2.schools;
  var headingId = useId();
  var school = schools.find(function (school) {
    return String(school.id) === String(programDetails.schoolId);
  });
  var programType = applicationProgram.programType;
  var programTypeLabel = programType === 'main' ? 'MAIN PROGRAM' : 'ESL PROGRAM';
  assert(school, "Could not find school for ".concat(programType, " program"));
  var programInternalUrl = "/schools/".concat(school.id, "/programs/").concat(programDetails.id);
  var schoolInternalUrl = "/schools/".concat(school.id);
  var formattedIntakeDetails = useFormattedIntakeDetails({
    startDate: applicationProgram.startDate,
    intake: intake
  });
  return _jsxs(_Fragment, {
    children: [_jsx(Text, {
      id: headingId,
      variant: "labelL",
      children: programTypeLabel
    }), _jsxs(SideBarDescriptionList, {
      "aria-labelledby": headingId,
      children: [_jsx(DescriptionList.Term, {
        children: t('programDetails.selectedIntake')
      }), _jsx(DescriptionList.Details, {
        children: _jsxs(Flex, {
          direction: "column",
          gap: 1,
          children: [_jsx(Copyable, {
            disabled: !copyEnabled,
            children: formattedIntakeDetails === null || formattedIntakeDetails === void 0 ? void 0 : formattedIntakeDetails.formattedDate
          }), (formattedIntakeDetails === null || formattedIntakeDetails === void 0 ? void 0 : formattedIntakeDetails.status) && _jsxs(Flex, {
            align: "center",
            gap: 2,
            children: [_jsx(Text, {
              contrast: formattedIntakeDetails.status.contrast,
              intent: formattedIntakeDetails.status.intent,
              variant: "bodyS",
              children: formattedIntakeDetails.status.label
            }), (formattedIntakeDetails === null || formattedIntakeDetails === void 0 ? void 0 : formattedIntakeDetails.status.infoText) && formattedIntakeDetails.status.intent && _jsx(Tooltip, {
              label: formattedIntakeDetails.status.infoText,
              children: _jsx(Tooltip.Icon, {
                intent: "secondary"
              })
            })]
          })]
        })
      }), _jsx(DescriptionList.Term, {
        children: t('programDetails.program')
      }), _jsx(DescriptionList.Details, {
        children: _jsx(Copyable, {
          disabled: !copyEnabled,
          children: _jsx(Link, {
            href: programInternalUrl,
            onClick: function onClick() {
              trackEvent({
                event: 'Application Details - Clicked Program Link',
                data: {
                  linkToProgram: programInternalUrl,
                  section: programTypeLabel
                }
              });
            },
            children: programDetails.name
          })
        })
      }), !(hiddenSections !== null && hiddenSections !== void 0 && hiddenSections.includes('applicationDetails.programId')) ? _jsxs(_Fragment, {
        children: [_jsx(DescriptionList.Term, {
          children: t('programDetails.programId')
        }), _jsx(DescriptionList.Details, {
          children: _jsx(Copyable, {
            disabled: !copyEnabled,
            children: programDetails.id
          })
        })]
      }) : _jsx(_Fragment, {}), _jsx(DescriptionList.Term, {
        children: t('programDetails.school')
      }), _jsx(DescriptionList.Details, {
        children: _jsx(Copyable, {
          disabled: !copyEnabled,
          children: _jsx(Link, {
            href: schoolInternalUrl,
            onClick: function onClick() {
              trackEvent({
                event: 'Application Details - Clicked School Link',
                data: {
                  linkToSchool: schoolInternalUrl,
                  section: programTypeLabel
                }
              });
            },
            children: school.name
          })
        })
      }), _jsx(DescriptionList.Term, {
        children: t('programDetails.country')
      }), _jsx(DescriptionList.Details, {
        children: _jsxs(Flex, {
          direction: "row",
          gap: 2,
          children: [_jsx(CountryFlag, {
            countryCode: school.countryCode
          }), _jsx(Text, {
            variant: "bodyM",
            children: _jsx(Copyable, {
              disabled: !copyEnabled,
              children: school.country
            })
          })]
        })
      }), _jsx(DescriptionList.Term, {
        children: t('programDetails.level')
      }), _jsxs(DescriptionList.Details, {
        children: [' ', _jsx(Copyable, {
          disabled: !copyEnabled,
          children: programDetails.levelText
        })]
      }), _jsx(DescriptionList.Term, {
        children: t('programDetails.deliveryMethod')
      }), _jsx(DescriptionList.Details, {
        children: _jsx(Copyable, {
          disabled: !copyEnabled,
          children: formatDeliveryMethod(programDetails.deliveryMethod)
        })
      }), programDetails.requiredLevel !== undefined ? _jsxs(_Fragment, {
        children: [_jsx(DescriptionList.Term, {
          children: t('programDetails.requiredLevel')
        }), _jsx(DescriptionList.Details, {
          children: _jsx(Copyable, {
            disabled: !copyEnabled,
            children: (_programDetails$requi = programDetails.requiredLevel) !== null && _programDetails$requi !== void 0 ? _programDetails$requi : '--'
          })
        })]
      }) : _jsx(_Fragment, {}), _jsx(DescriptionList.Term, {
        children: t('programDetails.submissionDeadline')
      }), _jsx(DescriptionList.Details, {
        children: _jsxs(Flex, {
          align: "center",
          gap: 2,
          children: [_jsx(Copyable, {
            disabled: !copyEnabled,
            children: applicationProgram.submissionDeadline ? formatDate(applicationProgram.submissionDeadline) : '--'
          }), applicationProgram.submissionDeadline && _jsx(Tooltip, {
            label: t('programDetails.submissionDeadlineTooltip', {
              deadline: formatDetailedDeadline(applicationProgram.submissionDeadline)
            }),
            children: _jsx(Tooltip.Icon, {
              intent: "secondary"
            })
          })]
        })
      }), !(hiddenSections !== null && hiddenSections !== void 0 && hiddenSections.includes('applicationDetails.program.submissionMethod')) && programDetails.submissionMethod !== undefined ? _jsxs(_Fragment, {
        children: [_jsx(DescriptionList.Term, {
          children: t('programDetails.submissionMethod')
        }), _jsx(DescriptionList.Details, {
          children: _jsx(Copyable, {
            disabled: !copyEnabled,
            children: (_programDetails$submi = programDetails.submissionMethod) !== null && _programDetails$submi !== void 0 ? _programDetails$submi : '--'
          })
        })]
      }) : _jsx(_Fragment, {})]
    })]
  });
};
function formatDate(date) {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}
function formatDeliveryMethod(deliveryMethod) {
  return deliveryMethod.charAt(0).toUpperCase() + deliveryMethod.slice(1).replace(/_/g, ' ');
}